<template>
  <div class="show">
    <enfold-uc>
      <template slot="up">
        <div class="tip"><span class="tit">{{ $t('schedule.planPre') }}</span></div>
      </template>
      <template slot="center">
        <template v-if="this.$pstore.state.finaldata.length != 0">
          <!-- <div :style="{'background-image':' url('+ $pstore.state.finaldata[$pstore.state.currentindex].pimg+ ')'}" class="imgd"></div> -->
          <img :src="$pstore.state.finaldata[$pstore.state.currentindex].pimg" style="width: 95%;
  height: 17%;object-fit: contain;background: #F4F4F5;" />
          <!-- <div style="margin: 4% auto; width: 95%; height: 20px;">{{ msFormatting($pstore.state.finaldata[$pstore.state.currentindex].playTime) }}</div> -->
          <div style="margin: 4% auto; width: 95%; height: 20px;">{{ $t('schedule.playTimes') }} : {{
            msFormatting($pstore.state.finaldata[$pstore.state.currentindex].playTime) }}</div>
        </template>

        <template v-else>
          <div class="imgd"></div>
        </template>
      </template>
    </enfold-uc>
  </div>
</template>

<script>
import EnfoldUc from "@/components/basics/EnfoldUC"
//i//mport Enfold from "@/components/basics/Enfold"
import { msFormatting } from "@/assets/scripts/dateFormatting.js";

export default {
  name: "ShowPreview",
  components: {
    EnfoldUc,
    //Enfold
  },
  data() {
    return {
      msFormatting: msFormatting,
    }
  }
}
</script>

<style lang="scss" scoped>
.tit {
  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3px;
  height: 16px;
  letter-spacing: 3px;
  color: #617883;
  padding-left: 2%;
}

.tit::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.show {
  height: 100%;
  width: 100%;
  border-left: 1px solid #cfd5d8;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.tip {
  height: 100%;
  width: 100%;
}

.preimg {
  /* background-color: black; */
  width: 80%;
  margin: 0 auto;
  flex-basis: 50%;
  position: relative;
}

.pimg {
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-50%, -50%);
}

.imgd {
  margin: 4% auto;
  width: 95%;
  height: 17%;
  border: 1px solid black;
  background-color: #000000;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
